export let DeafultListData = [
  "Dapibus ac facilisis in",
  "Morbi leo risus",
  "Porta ac consectetur ac",
  "Vestibulum at eros",
];

export let DynamicLinkButtonData = [
  { text: "Morbi leo risus" },
  { text: "Porta ac consectetur ac" },
  { text: "Cras justo odio" },
  { text: "Vestibulum at eros", disabled: true },
];

export let FlushStylesData = [
  "Dapibus ac facilisis in",
  "Morbi leo risus",
  "Porta ac consectetur ac",
  "Vestibulum at eros",
  "Cras justo odio",
  "Dapibus ac facilisis in",
  "Dapibus ac facilisis in",
  "Dapibus ac facilisis in",
];

export let ContextualClassData =[
{className: 'list-group-item list-group-item-primary' ,    text:"This is a primary list group item"      } ,
{className: 'list-group-item list-group-item-secondary'  ,  text:"This is a secondary list group item"      } ,
{className: 'list-group-item list-group-item-success' ,    text:"This is a success list group item"      } ,
{className: 'list-group-item list-group-item-danger' ,     text:"This is a danger list group item"      } ,
{className: 'list-group-item list-group-item-warning' ,    text:"This is a warning list group item"      } ,
{className: 'list-group-item list-group-item-info' ,       text:"This is a info list group item"      } ,
{className: 'list-group-item list-group-item-light' ,      text:"This is a light list group item"      } ,
{className: 'list-group-item list-group-item-dark' ,       text:"This is a dark list group item"      } ,

]

export let badgeWithPillData =[
  {  heading:"Dapibus ac facilisis in", spanText:"2",     spanClassName:"badge-secondary"},
  {  heading:"Morbi leo risus", spanText:"1",     spanClassName:"badge-success rounded-pill "},
  {  heading:"Dapibus ac facilisis in", spanText:"100%",     spanClassName:"badge-info rounded-pill "},
  {  heading:"Morbi leo risus", spanText:"2",     spanClassName:"badge-warning "},
  {  heading:"Cras justo odio", spanText:"sale",     spanClassName:"badge-danger rounded-pill "},
  {  heading:"Cras justo odio", spanText:"14",     spanClassName:"badge-light txt-dark "},
] 

export let DyanmicWithIconsData =[
  {icon:<i className="icon-target"></i>, text:'Dapibus ac facilisis in'},
  {icon:<i className="icon-mobile"></i>, text:'Morbi leo risus'},
  {liClass:"disabled" ,icon:<i className="icon-shopping-cart-full"></i> ,text:"Vestibulum at eros"}
]
export let CustomContentsBodydatas = [
  {
    LiClass: "list-group-item-action flex-column align-items-start active",
    Heading: "List group item heading",
    paragraphText:
      "Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius.",
  },
  {
    LiClass: "list-group-item-action flex-column align-items-start ",
    Heading: "List group item heading",
    SmallCLass: "text-muted",
    paragraphText:
      "Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius.",
  },
  {
    LiClass: "list-group-item-action flex-column align-items-start ",
    Heading: "List group item heading",
    SmallCLass: "text-muted",
    paragraphText:
      "Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius.",
  },
];